import { jsx } from 'react/jsx-runtime';
import { useState, useMemo, useCallback, useEffect } from 'react';
import { CopyToClipboardContext } from './context.es.js';

/**
 * CopyToClipboard Provider.
 */ const CopyToClipboardProvider = (props)=>{
    const { children, locale, masked, value, variant, ...rest } = props;
    const [isCopied, setIsCopied] = useState(false);
    const truncatedText = useMemo(()=>masked ? value.replaceAll(/./g, '∗') : value, [
        masked,
        value
    ]);
    const handleCopyClick = useCallback((e)=>{
        e.stopPropagation();
        setIsCopied(true);
        void navigator.clipboard.writeText(value);
    }, [
        value
    ]);
    useEffect(()=>{
        if (isCopied) {
            // arbitrary timeout of 3 seconds to show check icon indicating the value was copied to the clipboard
            const checkTimeout = setTimeout(()=>setIsCopied(false), 3000);
            return ()=>clearTimeout(checkTimeout);
        }
    }, [
        isCopied
    ]);
    // Memoized provider value.
    const values = useMemo(()=>({
            locale: locale ?? {
                beforeCopy: 'Copy to Clipboard',
                afterCopy: 'Copied!'
            },
            masked,
            value,
            variant: variant ?? 'input',
            isCopied,
            truncatedText,
            ...rest
        }), [
        isCopied,
        locale,
        masked,
        rest,
        truncatedText,
        value,
        variant
    ]);
    return jsx(CopyToClipboardContext.Provider, {
        value: [
            values,
            {
                handleCopyClick
            }
        ],
        children: children
    });
};

export { CopyToClipboardProvider };
//# sourceMappingURL=provider.es.js.map
